import isApp from "@src/utils/isApp";

const isMobile = window.innerWidth < 1280 || isApp;

export default isMobile;
